export interface InsidePage {
  id: string
  src: string
  alt: string
  caption: string
}

export const insidePages: InsidePage[] = [
  {
    id: 'hvac',
    src: 'https://cdn.magicpatterns.com/uploads/qdbatUNkUzxMAacrXLu27j/Captura_de_pantalla_2026-09-18_a_la(s)_10.06.54_p._m..png',
    alt: 'HVAC system inspection page with labelled equipment photo and condition checklist',
    caption: 'HVAC System Inspection',
  },
  {
    id: 'motor',
    src: 'https://cdn.magicpatterns.com/uploads/fQPN5QArogr7WdUsg2BWxj/Captura_de_pantalla_2026-09-18_a_la(s)_10.07.19_p._m..png',
    alt: 'Motor inspection page with labelled motor photo, inspection checklist and findings section',
    caption: 'Motor Inspection',
  },
  {
    id: 'lighting',
    src: 'https://cdn.magicpatterns.com/uploads/qr7MZVz5p9kthZGw5L2wey/Captura_de_pantalla_2026-09-18_a_la(s)_10.07.40_p._m..png',
    alt: 'Lighting inspection page with checklist, fixture summary table and area map',
    caption: 'Lighting Inspection',
  },
  {
    id: 'workflow',
    src: 'https://cdn.magicpatterns.com/uploads/vXs9LDbXSFSPLowiN7p1XN/Captura_de_pantalla_2026-09-18_a_la(s)_10.08.07_p._m..png',
    alt: 'Inspection-to-work-order workflow page with eight numbered steps and an example flow',
    caption: 'Inspection-to-Work-Order Workflow',
  },
  {
    id: 'photo',
    src: 'https://cdn.magicpatterns.com/uploads/asSVd1GXJ4v82ADBvF1RNd/Captura_de_pantalla_2026-09-18_a_la(s)_10.08.30_p._m..png',
    alt: 'Photo documentation guide page with context, detail and identification photo guidance',
    caption: 'Photo Documentation Guide',
  },
]
